import { render, staticRenderFns } from "./supportTerms.vue?vue&type=template&id=337d4030"
import script from "./supportTerms.vue?vue&type=script&lang=js"
export * from "./supportTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports